module.exports = __webpack_public_path__ + "img/platform-activities-60-days-in-row.3e0f671d.png";